export const BurgerMenuSVG = (props) => (
  <svg
    height={19}
    viewBox="0 0 20 19"
    width={20}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd" strokeWidth={1.2}>
      <path d="M0 1.5h20M0 9.5h20M0 17.5h20" />
    </g>
  </svg>
);
